import axios from "axios";

export default function adminCreateTicket(data) {
  const formData = new FormData();
  formData.append("company_id", data.company_id);
  formData.append("reporter_id", data.reporter_id);
  formData.append("reporter_name", data.reporter_name);
  formData.append("reporter_email", data.reporter_email);
  formData.append("reporter_company_name", data.reporter_company_name);
  formData.append("title", data.title);
  formData.append("description", data.description);
  formData.append("smartkood_module", data.smartkood_module);

  if (data.files) {
    data.files.forEach((file) => {
      formData.append("files[]", file);
    });
  }

  return new Promise((resolve, reject) =>
    axios
      .post("/support/api/v1/admin/tickets", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || error.message))
  );
}
